import script from "./RatingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RatingModal.vue?vue&type=script&setup=true&lang=ts"

import "./RatingModal.vue?vue&type=style&index=0&id=6184ad23&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6184ad23"]])

export default __exports__